import React, { Fragment, useState, useEffect } from "react";
import FsLightbox from "fslightbox-react";
import Chart from "react-apexcharts";

import {
  Row,
  Col,
  Image,
  Form,
  Nav,
  Dropdown,
  Tab,
  Table,
  Button,
  InputGroup,
} from "react-bootstrap";
import Card from "../Card";
import { FaTimes } from "react-icons/fa";
import { Link } from "react-router-dom";
// img

import avatars11 from "../../assets/images/avatars/01.png";
import avatars22 from "../../assets/images/avatars/avtar_1.png";
import avatars33 from "../../assets/images/avatars/avtar_2.png";
import avatars44 from "../../assets/images/avatars/avtar_3.png";
import avatars55 from "../../assets/images/avatars/avtar_4.png";
import avatars66 from "../../assets/images/avatars/avtar_5.png";
import avatars2 from "../../assets/images/avatars/02.png";
import avatars3 from "../../assets/images/avatars/03.png";
import avatars4 from "../../assets/images/avatars/04.png";
import avatars5 from "../../assets/images/avatars/05.png";

import icon1 from "../../assets/images/icons/01.png";
import icon2 from "../../assets/images/icons/02.png";
import icon3 from "../../assets/images/icons/03.png";
import icon4 from "../../assets/images/icons/04.png";
import icon8 from "../../assets/images/icons/08.png";
import icon6 from "../../assets/images/icons/06.png";
import icon7 from "../../assets/images/icons/07.png";

import icon5 from "../../assets/images/icons/05.png";
import shap2 from "../../assets/images/shapes/02.png";
import shap4 from "../../assets/images/shapes/04.png";
import shap6 from "../../assets/images/shapes/06.png";
import pages2 from "../../assets/images/pages/02-page.png";
import Progress from "../progress.js";

import SubscriptionTable from "./subscriptionTable";
import AutoPayTable from "./autoPayTable";
import PlanTable from "./planTable";

import {
  FaFilter,
  FaRedo,
  FaPlus,
  FaArrowDown,
  FaTrash,
  FaSort,
  FaTrashAlt,
  FaSearch,
} from "react-icons/fa";

const LicenseManagment = () => {
  console.log("license!!")
  const getVariableColor = () => {
    let prefix =
      getComputedStyle(document.body).getPropertyValue("--prefix") || "bs-";
    if (prefix) {
      prefix = prefix.trim();
    }
    const color1 = getComputedStyle(document.body).getPropertyValue(
      `--${prefix}primary`
    );
    const color2 = getComputedStyle(document.body).getPropertyValue(
      `--${prefix}info`
    );
    const color3 = getComputedStyle(document.body).getPropertyValue(
      `--${prefix}primary-tint-20`
    );
    const color4 = getComputedStyle(document.body).getPropertyValue(
      `--${prefix}warning`
    );
    return {
      primary: color1.trim(),
      info: color2.trim(),
      warning: color4.trim(),
      primary_light: color3.trim(),
    };
  };
  const variableColors = getVariableColor();

  const colors = [variableColors.primary, variableColors.info];
  useEffect(() => {
    return () => colors;
  });
  const chart1 = {
    options: {
      chart: {
        fontFamily:
          '"Inter", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
        toolbar: {
          show: false,
        },
        sparkline: {
          enabled: false,
        },
      },
      colors: colors,
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        width: 3,
      },
      yaxis: {
        show: true,
        labels: {
          show: true,
          minWidth: 19,
          maxWidth: 19,
          style: {
            colors: "#8A92A6",
          },
          offsetX: -5,
        },
      },
      legend: {
        show: false,
      },
      xaxis: {
        labels: {
          minHeight: 22,
          maxHeight: 22,
          show: true,
          style: {
            colors: "#8A92A6",
          },
        },
        lines: {
          show: false, //or just here to disable only x axis grids
        },
        categories: ["Jan", "Feb", "Mar", "Apr", "Jun", "Jul", "Aug"],
      },
      grid: {
        show: false,
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "dark",
          type: "vertical",
          shadeIntensity: 0,
          gradientToColors: undefined, // optional, if not defined - uses the shades of same color in series
          inverseColors: true,
          opacityFrom: 0.4,
          opacityTo: 0.1,
          stops: [0, 50, 80],
          colors: colors,
        },
      },
      tooltip: {
        enabled: true,
      },
    },
    series: [
      {
        name: "total",
        data: [94, 80, 94, 80, 94, 80, 94],
      },
      {
        name: "pipline",
        data: [72, 60, 84, 60, 74, 60, 78],
      },
    ],
  };

  console.log("hrrra?");
  const [toggler, setToggler] = useState();
  return (
    <Fragment>
      <FsLightbox
        toggler={toggler}
        sources={[
          icon4,
          shap2,
          icon8,
          shap4,
          icon2,
          shap6,
          icon5,
          shap4,
          icon1,
        ]}
      />
      <Tab.Container defaultActiveKey="first">
        <Row>
          <Col lg="12">
            <Card>
              <Card.Body>
                <div className="d-flex flex-wrap align-items-center justify-content-between">
                  <div className="d-flex flex-wrap align-items-center">
                    <div className="d-flex flex-wrap align-items-center mb-3 mb-sm-0">
                      <h4 className="me-2 h4">License Management</h4>
                    </div>
                  </div>
                </div>
                <div style={{ marginTop: "2%" }}>
                  <Nav
                    as="ul"
                    className="d-flex nav-tabs mr-3 mb-0 text-center profile-tab"
                    data-toggle="slider-tab"
                    id="profile-pills-tab"
                    role="tablist"
                  >
                    <Nav.Item as="li" className="me-3">
                      <Nav.Link eventKey="first">Usage</Nav.Link>
                    </Nav.Item>
                    <Nav.Item as="li" className="me-3">
                      <Nav.Link eventKey="second">Plans</Nav.Link>
                    </Nav.Item>
                    <Nav.Item as="li" className="me-3">
                      <Nav.Link eventKey="third">Subscriptions</Nav.Link>
                    </Nav.Item>
                    <Nav.Item as="li" className="me-3">
                      <Nav.Link eventKey="fourth">Services</Nav.Link>
                    </Nav.Item>
                    <Nav.Item as="li">
                      <Nav.Link eventKey="fifth">Auto Pay</Nav.Link>
                    </Nav.Item>
                  </Nav>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col lg="12">
            <Tab.Content className="profile-content">
              <Tab.Pane eventKey="first" id="profile-feed">
                <Row>
                  <Col lg="3" md="6">
                    <Card className="border-bottom border-4 border-0 border-primary">
                      <Card.Body>
                        <div
                          className="d-flex flex-column justify-content-center align-items-center text-center"
                          style={{ height: "100%" }}
                        >
                          <div>
                            <h5>Estimated License Cost</h5>
                          </div>
                          <div
                            className="d-flex align-items-center"
                            style={{ justifyContent: "space-between" }}
                          >
                            <div style={{ marginRight: "20px" }}>
                              <h5>₹1000k</h5>
                            </div>
                            <div>
                              <span>Per Year</span>
                            </div>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col lg="3" md="6">
                    <Card className="border-bottom border-4 border-0 border-primary">
                      <Card.Body>
                        <div
                          className="d-flex flex-column justify-content-center align-items-center text-center"
                          style={{ height: "100%" }}
                        >
                          <div>
                            <h5>Estimated License Cost</h5>
                          </div>
                          <div
                            className="d-flex align-items-center"
                            style={{ justifyContent: "space-between" }}
                          >
                            <div style={{ marginRight: "20px" }}>
                              <h5>₹1000k</h5>
                            </div>
                            <div>
                              <span>Per Year</span>
                            </div>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col lg="3" md="6">
                    <Card className="border-bottom border-4 border-0 border-primary">
                      <Card.Body>
                        <div
                          className="d-flex flex-column justify-content-center align-items-center text-center"
                          style={{ height: "100%" }}
                        >
                          <div>
                            <h5>Estimated License Cost</h5>
                          </div>
                          <div
                            className="d-flex align-items-center"
                            style={{ justifyContent: "space-between" }}
                          >
                            <div style={{ marginRight: "20px" }}>
                              <h5>₹1000k</h5>
                            </div>
                            <div>
                              <span>Per Year</span>
                            </div>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col lg="3" md="6">
                    <Card className="border-bottom border-4 border-0 border-primary">
                      <Card.Body>
                        <div
                          className="d-flex flex-column justify-content-center align-items-center text-center"
                          style={{ height: "100%" }}
                        >
                          <div>
                            <h5>Estimated License Cost</h5>
                          </div>
                          <div
                            className="d-flex align-items-center"
                            style={{ justifyContent: "space-between" }}
                          >
                            <div style={{ marginRight: "20px" }}>
                              <h5>₹1000k</h5>
                            </div>
                            <div>
                              <span>Per Year</span>
                            </div>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>

                <Col md="12" lg="12">
                  <Row>
                    <Col lg="4">
                      <Card>
                        <Card.Header className="d-flex justify-content-center align-items-center">
                          <h4 className="card-title">Requiring Attention</h4>
                        </Card.Header>
                        <hr className="mb-0 border-2 border-secondary" />

                        <Card.Body>
                          <div className="d-flex justify-content-between align-items-center">
                            <div className="d-flex align-items-center">
                              <FaTimes className="text-danger me-2" />{" "}
                              <h6 className="mb-0">Expired Licenses</h6>
                            </div>
                            <span className="fw-bold">24</span>
                          </div>

                          <hr className="my-3 border-2 border-secondary" />

                          <div className="d-flex justify-content-between align-items-center">
                            <div className="d-flex align-items-center">
                              <FaTimes className="text-danger me-2" />
                              <h6 className="mb-0">Expiring Soon</h6>
                            </div>
                            <span className="fw-bold">12</span>
                          </div>

                          <hr className="my-3 border-2 border-secondary" />

                          <div className="d-flex justify-content-between align-items-center">
                            <div className="d-flex align-items-center">
                              <FaTimes className="text-danger me-2" />
                              <h6 className="mb-0">Unassigned Licenses</h6>
                            </div>
                            <span className="fw-bold">8</span>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col md="12" lg="8">
                      <div
                        className="card"
                        data-aos="fade-up"
                        data-aos-delay="800"
                      >
                        <div className="flex-wrap card-header d-flex justify-content-between">
                          <div className="header-title">
                            <h4 className="card-title">$855.8K</h4>
                            <p className="mb-0">Gross Sales</p>
                          </div>
                          <div className="d-flex align-items-center align-self-center">
                            <div className="d-flex align-items-center text-primary">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                              >
                                <g>
                                  <circle
                                    cx="12"
                                    cy="12"
                                    r="8"
                                    fill="currentColor"
                                  ></circle>
                                </g>
                              </svg>
                              <div className="ms-2">
                                <span className="text-gray">Sales</span>
                              </div>
                            </div>
                            <div className="d-flex align-items-center ms-3 text-info">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                              >
                                <g>
                                  <circle
                                    cx="12"
                                    cy="12"
                                    r="8"
                                    fill="currentColor"
                                  ></circle>
                                </g>
                              </svg>
                              <div className="ms-2">
                                <span className="text-gray">Cost</span>
                              </div>
                            </div>
                          </div>
                          <Dropdown>
                            <Dropdown.Toggle
                              as={Button}
                              variant="text-gray"
                              type="button"
                              id="dropdownMenuButtonSM"
                            >
                              This Week
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item href="#">This Week</Dropdown.Item>
                              <Dropdown.Item href="#">This Month</Dropdown.Item>
                              <Dropdown.Item href="#">This Year</Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                        <div className="card-body">
                          <Chart
                            options={chart1.options}
                            series={chart1.series}
                            type="area"
                            height="245"
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Tab.Pane>
              <Tab.Pane eventKey="second" id="profile-activity">
                <AutoPayTable></AutoPayTable>
                {/* <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <Button variant="primary" className="d-flex align-items-center">
                <FaPlus className="me-2" /> Plan
              </Button>
              <div className="d-flex align-items-center">
           
                <InputGroup style={{ width: "300px" }} className="me-2">
                  <InputGroup.Text>
                    <FaSearch />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={handleSearch}
                    className="rounded"
                  />
                </InputGroup>
                <Button variant="light" className="me-2">
                  <FaFilter />
                </Button>
                <Button variant="light" className="me-2">
                  <FaRedo />
                </Button>
              </div>
            </Card.Header>
            <Card.Body>
              <div
                className="table-responsive border border-secondary rounded"
                style={{ padding: "1rem" }}
              >
                <Table hover>
                  <thead>
                    <tr>
                      <th onClick={() => handleSort("name")}>
                        Name <FaSort />
                      </th>
                      <th onClick={() => handleSort("type")}>
                        Type <FaSort />
                      </th>
                      <th onClick={() => handleSort("validity")}>
                        Validity <FaSort />
                      </th>
                      <th onClick={() => handleSort("discount")}>
                        Discount <FaSort />
                      </th>
                      <th onClick={() => handleSort("status")}>
                        Status <FaSort />
                      </th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData.map((item, index) => (
                      <tr
                        key={index}
                        style={{
                          border: "1px solid #ddd",
                          backgroundColor: "#f9f9f9",
                        }}
                      >
                        <td>{item.name}</td>
                        <td>{item.type}</td>
                        <td>{item.validity}</td>
                        <td>{item.discount}</td>
                        <td>
                          <span
                            className={`badge ${
                              item.status === "Active"
                                ? "bg-success"
                                : "bg-danger"
                            }`}
                          >
                            {item.status}
                          </span>
                        </td>
                        <td>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="light"
                              size="sm"
                              className="border-0"
                            >
                              Actions
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() => handleDelete(index)}
                              >
                                <FaTrashAlt className="me-2 text-danger" />{" "}
                                Delete
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                {!filteredData.length && (
                  <p className="text-center">No results found.</p>
                )}
              </div>
            </Card.Body>
          </Card>
        </Col> */}
              </Tab.Pane>
              <Tab.Pane eventKey="third" id="profile-friends">
                <SubscriptionTable></SubscriptionTable>
              </Tab.Pane>
              <Tab.Pane eventKey="fourth" id="profile-profile">
                {/* <Card>
                  <Card.Header>
                    <div className="header-title">
                      <h4 className="card-title">Profile</h4>
                    </div>
                  </Card.Header>
                  <Card.Body>
                    <div className="text-center">
                      <div className="user-profile">
                        <Image
                          className="theme-color-default-img  rounded-pill avatar-130 img-fluid"
                          src={avatars11}
                          alt="profile-pic"
                        />
                        <Image
                          className="theme-color-purple-img rounded-pill avatar-130 img-fluid"
                          src={avatars22}
                          alt="profile-pic"
                        />
                        <Image
                          className="theme-color-blue-img rounded-pill avatar-130 img-fluid"
                          src={avatars33}
                          alt="profile-pic"
                        />
                        <Image
                          className="theme-color-green-img rounded-pill avatar-130 img-fluid"
                          src={avatars55}
                          alt="profile-pic"
                        />
                        <Image
                          className="theme-color-yellow-img rounded-pill avatar-130 img-fluid"
                          src={avatars66}
                          alt="profile-pic"
                        />
                        <Image
                          className="theme-color-pink-img rounded-pill avatar-130 img-fluid"
                          src={avatars44}
                          alt="profile-pic"
                        />
                      </div>
                      <div className="mt-3">
                        <h3 className="d-inline-block">Austin Robertson</h3>
                        <p className="d-inline-block pl-3"> - Web developer</p>
                        <p className="mb-0">
                          Lorem Ipsum is simply dummy text of the printing and
                          typesetting industry. Lorem Ipsum has been the
                          industry's standard dummy text ever since the 1500s
                        </p>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
                <Card>
                  <Card.Header>
                    <div className="header-title">
                      <h4 className="card-title">About User</h4>
                    </div>
                  </Card.Header>
                  <Card.Body>
                    <div className="user-bio">
                      <p>
                        Tart I love sugar plum I love oat cake. Sweet roll
                        caramels I love jujubes. Topping cake wafer.
                      </p>
                    </div>
                    <div className="mt-2">
                      <h6 className="mb-1">Joined:</h6>
                      <p>Feb 15, 2021</p>
                    </div>
                    <div className="mt-2">
                      <h6 className="mb-1">Lives:</h6>
                      <p>United States of America</p>
                    </div>
                    <div className="mt-2">
                      <h6 className="mb-1">Email:</h6>
                      <p>
                        <Link to="#" className="text-body">
                          {" "}
                          austin@gmail.com
                        </Link>
                      </p>
                    </div>
                    <div className="mt-2">
                      <h6 className="mb-1">Url:</h6>
                      <p>
                        <Link to="#" className="text-body" target="_blank">
                          {" "}
                          www.bootstrap.com{" "}
                        </Link>
                      </p>
                    </div>
                    <div className="mt-2">
                      <h6 className="mb-1">Contact:</h6>
                      <p>
                        <Link to="#" className="text-body">
                          (001) 4544 565 456
                        </Link>
                      </p>
                    </div>
                  </Card.Body>
                </Card> */}
              </Tab.Pane>
              <Tab.Pane eventKey="fifth" id="profile-profile">
                <AutoPayTable></AutoPayTable>
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </Fragment>
  );
};

export default LicenseManagment;
